const AssetsEnum = {
  BTC: "BTC",
  LTC: "LTC",
  BCH: "BCH",
  BSV: "BSV",
  DOGE: "DOGE",

  ETH: "ETH",
  ETC: "ETC",
  BNB: "BNB",
  MATIC: "MATIC",
  AVAX: "AVAX",
  ARB: "ARB",
  OP: "OP",
  BASE: "BASE",

  TRX: "TRX",
  ALGO: "ALGO",
  ADA: "ADA",
  ZEC: "ZEC",
  SOL: "SOL",
  DOT: "DOT",

  XRP: "XRP",
  XLM: "XLM",

  USDT: "USDT",
  USDC: "USDC",
  DAI: "DAI",

  LINK: "LINK",
  AAVE: "AAVE",
  NEAR: "NEAR",
  XTZ: "XTZ",
  APT: "APT",

  BSC: "BSC",
  TON: "TON",
  USD: "USD",
  USDTERC20: "USDTERC20",
  USDTTRC20: "USDTTRC20",
  BTG: "BTG",
  XVG: "XVG",
  QTUM: "QTUM",
  KMD: "KMD",
  BAT: "BAT",
  WAVES: "WAVES",
  TUSD: "TUSD",
  ZEN: "ZEN",
  FUN: "FUN",
  RVN: "RVN",
  BEL: "BEL",
  C98: "C98",
  ZIL: "ZIL",
  LUNA: "LUNA",
} as const;

export { AssetsEnum };
